var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.uiVersion == 3
    ? _c("div", { staticClass: "mobile-scroller" }, [
        _c("div", { staticClass: "mobile-scroller__wrapper" }, [
          _c(
            "div",
            { staticClass: "row flex-nowrap flex-lg-wrap blog__row" },
            _vm._l(this.blogPosts, function(blogPost) {
              return _c("BlogPost", {
                key: blogPost.guid,
                attrs: { post: blogPost }
              })
            }),
            1
          )
        ])
      ])
    : this.uiVersion == 2
    ? _c(
        "div",
        { staticClass: "row blogposts" },
        _vm._l(this.blogPosts, function(blogPost) {
          return _c("BlogPost", {
            key: blogPost.guid,
            attrs: { post: blogPost }
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }